import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const SettingsKeyIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 22.036 22.036"
    >
      <g transform="translate(1.036 1.036)">
        <path
          d="M456.8,195.68l2.024,2.024c1.655,1.655,2.336,3.681.681,5.336s-3.681.973-5.335-.681l-2.024-2.025a6.324,6.324,0,0,0,6.465,7.828l6.1,6.1a4.255,4.255,0,0,0,6.017-6.017l-6.1-6.1a6.324,6.324,0,0,0-7.827-6.465Z"
          transform="translate(-451.968 -195.499)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
